declare namespace $ {

	export class $mol_view_tree2_to_js_test_ex_bidi_with_default_object_foo extends $mol_object {
		owner( next?: $mol_object ): $mol_object
		class( next?: ReturnType< $mol_view_tree2_to_js_test_ex_bidi_with_default_object_foo['owner'] > ): ReturnType< $mol_view_tree2_to_js_test_ex_bidi_with_default_object_foo['owner'] >
	}
	
}

//# sourceMappingURL=bidi_with_default_object.view.tree.d.ts.map